module.exports = __webpack_public_path__ + "static/media/image-card-5.7358c889.png";